export default "__VITE_ASSET__Q2f_qb5p__"